import { ReactNode } from "react";
// import styles from "./PopupTemplate.module.scss";

import { Skeleton } from "components/Skeleton";
import { Wrapper } from "./styles";

type Props = {
  renderButtons?: ReactNode;
  children: ReactNode;
};

function PopupTemplateSkeleton({ children, renderButtons }: Props) {
  return (
    <Wrapper>
      <div className="container">
        <div className="header">
          <header>
            <div className={`${"title"} ${"skeleton"}`}>
              <Skeleton width="10em" height={18} />
            </div>
            <div className={"coordText"}>
              <Skeleton width="10em" />
            </div>
          </header>

          <button className={"closeButton"} type="button">
            <Skeleton width="10em" rounded />
          </button>
        </div>

        <div className={"body"}>
          <div
            className={`${"buttonContainer"} ${"skeleton"} ${
              !children && "withoutDivider"
            }`}
          >
            {renderButtons}
          </div>
        </div>

        {children}
      </div>
    </Wrapper>
  );
}

export { PopupTemplateSkeleton };
